import * as React from 'react';
/**
 *
 * Original name: upload folder
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A305
 *
 */
export const UploadFolderPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m31.029 16-3.206-4.487A6.011 6.011 0 0 0 22.941 9H8v35a6.007 6.007 0 0 0 6 6h12v-4H14a2 2 0 0 1-2-2V13h10.941a2 2 0 0 1 1.627.837L28.971 20H52v24a2 2 0 0 1-2 2H38v4h12a6.007 6.007 0 0 0 6-6V16H31.029Z", fill: "currentColor" }),
    React.createElement("path", { d: "M39.895 38.211A11.347 11.347 0 0 1 34 32h-4a11.352 11.352 0 0 1-5.895 6.211l1.789 3.578A16.773 16.773 0 0 0 30 38.926V50h4V38.926a16.774 16.774 0 0 0 4.105 2.864l1.79-3.579Z", fill: "currentColor" })));
